import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";

import { environment as ENV } from "environments/environment";
import { SucursalPersonaDTO } from "../../interfaces/sucursal-persona.interface";
import { NuevaSucursalDTO } from "../../models/sucursal-model";
const API = "clientes";

@Injectable({
    providedIn: "root",
})
export class SucursalesService {
    constructor(private http: HttpClient) {}

    fetchSucursalesCliente(idCliente: number): Observable<SucursalPersonaDTO[]> {
        return this.http.get<SucursalPersonaDTO[]>(
            `${ENV.apiUrl}${API}/${idCliente}/sucursales`
        );
    }

    save(idCliente: number, nuevo: NuevaSucursalDTO): Observable<any> {
        return this.http.post(
            `${ENV.apiUrl}${API}/${idCliente}/sucursal`,
            nuevo
        );
    }

    update(idSucursal: number, nuevo: NuevaSucursalDTO): Observable<any> {
        //console.log("actualiza sucursal");
        //console.log(nuevo);

        return this.http.patch(
            `${ENV.apiUrl}${API}/sucursal/${idSucursal}`,
            nuevo
        );
    }

    delete(idSucursal: number): Observable<any> {
        return this.http.delete<any>(
            `${ENV.apiUrl}${API}/sucursal/${idSucursal}`
        );
    }

    ///api/clientes/{idCliente}/{idSucursal}
    fetchSucursal(idCliente: number, idSucursal: number) {
        return this.http.get<SucursalPersonaDTO>(
            `${ENV.apiUrl}${API}/${idCliente}/${idSucursal}`
        );
    }
}
